export default __webpack_public_path__ + "static/media/footer-background.4dc63e01.svg";